import classNames from "classnames";
import { createUseStyles } from "react-jss";
import SectionBlock from "../../../Components/SectionBlock";
import Input from "../../../Components/Form/Input";
import DateInput from "../../../Components/Form/DateInput";
import Button from "../../../Components/Button";
import { globe } from "../../../Assets/Images";
import { useState } from "react";

const formInputs = [
  {
    name: "firstName",
    label: "First Name",
    placeholder: "Your First Name",
    required: true,
  },
  {
    name: "lastName",
    label: "Last Name",
    placeholder: "Your Last Name",
    required: true,
  },
  {
    name: "sex",
    label: "Sex",
    placeholder: "Your Sex",
    required: true,
  },
  {
    name: "dob",
    label: "Date of Birth",
    placeholder: "Your Date of Birth",
    required: true,
    Component: DateInput,
  },
  {
    name: "address",
    label: "Address",
    placeholder: "Your Address",
    required: true,
  },
  {
    name: "city",
    label: "City",
    placeholder: "City",
    required: true,
  },
  {
    name: "state",
    label: "State",
    placeholder: "State",
    required: true,
  },
  {
    name: "zip",
    label: "Zip Code",
    placeholder: "Zip Code",
    required: true,
  },
];

interface Props {
  className?: string;
}

const useStyles = createUseStyles({
  root: {},
  formWrapper: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  formInput: {
    flexBasis: "48%",
    marginBottom: "25px",
  },
  formActions: {
    marginTop: "25px",
    width: "100%",
    justifyContent: "center",
    display: "flex",
    flexDirection: "row",
  },
  submitButton: {},
});

const PatientRegistrationForm = ({ className }: Props) => {
  const [formState, setFormState] = useState({});
  const classes = useStyles();

  const handleOnChange = (name: string, value: string) => {
    setFormState({
      ...formState,
      [name]: value,
    });
  };
  const handleSubmit = () => {
    const jsonString = JSON.stringify(formState, null, 2);
    alert(`Thanks for registering!\nPatient Data Submitted:\n${jsonString}`);
  };

  return (
    <div className={classNames(classes.root, className)}>
      <SectionBlock
        variant="white"
        header="Patient Portal Registration"
        description="This is the sample form for submitting Patient registration information"
        image={globe}
        textAlign="center"
      >
        <div className={classes.formWrapper}>
          {formInputs.map((input) => {
            const InputElement = input.Component;
            const Element = InputElement ? InputElement : Input;
            return (
              <Element
                required={input.required}
                name={input.name}
                label={input.label}
                placeholder={input.placeholder}
                onChange={(name, value) => handleOnChange(name, value)}
                errorMessage={`${input.label} is required`}
                className={classes.formInput}
              />
            );
          })}
          <div className={classes.formActions}>
            <Button
              onClick={() => handleSubmit()}
              label="Submit My Information"
              className={classes.submitButton}
            />
          </div>
        </div>
      </SectionBlock>
    </div>
  );
};

export default PatientRegistrationForm;
